// extracted by mini-css-extract-plugin
export var readonly = "_jm-1";
export var star = "_jm-0";